import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 pt-[68px] flex items-center">
        <div className="w-full px-4 md:px-8 py-20 text-center">
          <p className="font-heading text-6xl md:text-8xl text-primary-500 tracking-wide">404</p>
          <h1 className="mt-4 font-heading text-2xl md:text-4xl tracking-wide text-foreground-950">
            这个页面还没被爆料出来
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-md mx-auto">
            你访问的地址暂时不存在。可以回到首页，或者直接去评选专区看看当前的入围名单与排名结果。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/finalists"
              className="px-7 py-3.5 rounded-md border border-foreground-300 text-foreground-800 font-medium text-sm whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
            >
              浏览入围名单
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}